import { createI18n } from "vue-i18n"

import * as sentryReporter from "@/services/sentryReporter.js"

import { useConfigurationStore } from "@/store/configuration.js"

import en from "@/translations/en.json"

const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en
  }
})

//Remove empty values to make vue-i18n use fallback value for missing keys
const removeEmpty = (messages) =>
  Object.keys(messages)
    .filter((k) => messages[k])
    .reduce(
      (newObj, k) => (typeof messages[k] === "object" ? Object.assign(newObj, { [k]: removeEmpty(messages[k]) }) : Object.assign(newObj, { [k]: messages[k] })),
      {}
    )

export const i18nSetup = async () => {
  const configurationStore = useConfigurationStore()
  //Available languages are defined by the host
  const availableLanguages = configurationStore.configuration.availableLanguages

  const translationFiles = import.meta.glob("@/translations//*.json")

  //Supported languages are languages that PWA has translation files for
  const supportedAlternativeLanguages = Object.keys(translationFiles)
    .map((path) => path.match(/\/(\w+)\.json$/)?.[1] || "")
    .filter((lang) => lang && lang !== "en")

  const lang = window.navigator.language || "en"
  const shortLang = lang.split("-")[0].split("_")[0].toLowerCase()

  if (!supportedAlternativeLanguages.includes(shortLang) || !availableLanguages.includes(shortLang)) {
    return
  }

  try {
    const messagesLoader = translationFiles[`/src/translations/${shortLang}.json`]
    if (!messagesLoader) {
      return
    }

    const { default: messages } = await messagesLoader()
    i18n.global.setLocaleMessage(shortLang, removeEmpty(messages))
    i18n.global.locale = shortLang
  } catch (err) {
    sentryReporter.reportError(err)
  }
}

export default i18n
